<template>
    <v-dialog scrollable v-model="socialNetworkDialog" content-class="medium">
        <v-card class="myprofile-popup">
            <v-card-title primary-title>
                {{memberProfileConstants.CONTACT_INFORMATION.EDIT_MY_SOCIAL_NETWORKS}}
                <i class="fas fa-times" data-qe-id="close_dialog_btn" @click="closeSocialNetworkDialog()"></i>
            </v-card-title>
             <v-card-text v-if="socialNetworkDialog" class="inner-scrollbar social-network-edit">
                <v-form ref="socialNetworksEditForm" v-model="valid" lazy-validation>
                    <span class="required-label" mr-2>{{memberProfileConstants.REQUIRED}}</span>
                    <v-layout row wrap>
                        <v-flex xs12 sm6>
                            <v-flex class="form-control">
                                <span class="select-label">{{memberProfileConstants.CONTACT_INFORMATION.SOCIAL_NETWORK_NAME}} {{memberProfileConstants.ASTERISK}}</span>
                                <v-autocomplete
                                    attach
                                    data-qe-id="social-network_select"
                                    v-model="selectedNetwork"
                                    :rules="memberProfileConstants.CONTACT_INFORMATION.SOCIAL_NETWORK_RULE"
                                    color="ypo_blue"
                                    :items="socialNetworkTypes"
                                    item-text="socialNetworkName"
                                    v-on:change="enableDoneButton()"
                                    required>
                                </v-autocomplete>
                            </v-flex>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-flex class="form-control">
                                <span class="select-label">{{memberProfileConstants.URL}}</span>
                                <v-text-field
                                    color="ypo_blue"
                                    data-qe-id="social-network_url"
                                    :placeholder="memberProfileConstants.URL"
                                    v-model="urlData">
                                </v-text-field>
                            </v-flex>
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-flex text-xs-right pa-3>
                    <status-bar :action="saveSocialNetworkAction"></status-bar>
                    <v-btn class="primary_btn transparent" data-qe-id="cancel_dialog_btn" @click="closeSocialNetworkDialog()">
                        {{appCommonConstants.CANCEL}}
                    </v-btn>
                    <v-btn
                        class="primary_btn"
                        data-qe-id="save_dialog_btn"
                        @click="updateSocialNetworks()"
                        :disabled="!valid || !socialNetworkFormValid">
                        {{appCommonConstants.DONE}}
                    </v-btn>
                </v-flex>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import { appCommonConstants } from "../../appCommon.constants.js";
    import { mapActions, mapGetters, mapState } from "vuex";
    import { memberProfileConstants } from ".././memberProfile.constants.js";
    import { storeAction } from "../../../store/storeActions.constant";
    import { storeGetters } from "../../../store/storeGetters.constant";
    import StatusBar from "../../StatusBar/StatusBar";
    import { eventBus } from '../../../main';
    import { gtmEventName } from "@/plugins/gtmAnalytics";
    import { gaDataLayerEvent } from "@/plugins/analytics";

    export default {
        name: "SocialNetworkEdit",
        data: () => ({
            valid: false,
            appCommonConstants,
            memberProfileConstants,
            selectedNetwork: null,
            socialNetworkFormValid: false,
            urlData: null,
            socialNetworks: {
                Facebook: null,
                Instagram: null,
                LinkedIn: null,
                Skype: null,
                Twitter: null,               
                WhatsApp: null,               
            },
        }),
        components: {
            StatusBar,
        },
        props: {
            visible: {
                type: Boolean,
            },
            memberId: {
                type: String,
                required: true,
            },
        },
        created() {
            this.getContactInformation(this.memberId);
            eventBus.$on('socialNetworkDialog', ((value) => {
                this.socialNetworkDialog = value;
            }));
        },
        methods: {
            ...mapActions({
                getContactInformation: `memberProfile/${storeAction.getContactInformation}`,
                updateSocialNetworkDetails: `memberProfile/${storeAction.updateSocialNetworkDetails}`,
            }),
            enableDoneButton() {
                this.socialNetworkFormValid = true;
            },
            updateSocialNetworks() {
                const ref = this.$refs.socialNetworksEditForm;
                const parms = {
                    personId: this.memberId,
                    socialNetworkInfo: this.socialNetworks,
                    doesNotParticipateInSocialMedia: false,
                };
                if (ref && ref.validate && ref.validate()) {
                    this.socialNetworkFormValid = true;
                    this.socialNetworks[this.selectedNetwork] = this.urlData;
                    this.updateSocialNetworkDetails({ ...parms }).then(() => {
                        this.closeSocialNetworkDialog();
                        gaDataLayerEvent(gtmEventName.C_Profile_Edit, `Social Media - ${this.memberId}${this.isRedirectFromConnectPlus ? ' | Connect+ Redirect' : ''}`);
                    });
                } else {
                    this.socialNetworkFormValid = false;
                }
            },
            closeSocialNetworkDialog() {
                this.socialNetworks = [];
                this.selectedNetwork = null;
                this.socialNetworkFormValid = false;
                this.urlData = null;
                this.socialNetworkDialog = false;
            },
        },
        computed: {
            socialNetworkDialog: {
                get() {
                    return this.visible;
                },
                set(value) {
                    if (!value) {
                        this.$emit('close');
                    }
                },
            },
            ...mapGetters({
                socialNetworkTypes: `memberProfile/${storeGetters.socialNetworkTypes}`,
                contactInformation: `memberProfile/${storeGetters.contactInformation}`,
            }),
            ...mapState("actionState", ["actions"]),
            saveSocialNetworkAction() {
                return this.actions[storeAction.updateSocialNetworkDetails];
            },
            isRedirectFromConnectPlus() {
              return this.$route && this.$route.query
                  && this.$route.query.connectPlusRedirect && this.$route.query.connectPlusRedirect === 'true';
            },
        },
        watch: {
            contactInformation(val) {
                if (val) {
                    this.socialNetworks.Facebook = val.facebookURL;
                    this.socialNetworks.Instagram = val.instagram;
                    this.socialNetworks.Twitter = val[memberProfileConstants.X_FORMERLY_TWITTER] || val.twitterUrl;
                    this.socialNetworks.WhatsApp = val.whatsApp;
                    this.socialNetworks.LinkedIn = val.linkedIn;
                    this.socialNetworks.Skype = val.skype;                   
                }
            },
            selectedNetwork: {
        handler(newval, oldval) {
            if (newval !== oldval) {
                if (newval === memberProfileConstants.X_FORMERLY_TWITTER) {
                    this.urlData = this.socialNetworks.Twitter || "";
                } else {
                    this.urlData = this.socialNetworks[newval] || "";
                }
            }
        },
        deep: true,
    },
        },
    };
</script>
<style lang="scss">
.social-network-edit {
  height: 345px
}
</style>
